import React from "react";
import styled, { css } from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const variants = {
  primary: css`
    background: ${COLORS.BTN_GREEN};
    color: ${COLORS.PRIMARY_WHITE};
    border: none;
    box-shadow: 0 2px 6px rgba(0, 131, 140, 0.22);
    &:hover:not(:disabled) { filter: brightness(0.95); }
  `,
  secondary: css`
    background: ${COLORS.PRIMARY_WHITE};
    color: #5c6b7f;
    border: 1.5px solid ${COLORS.BORDER_GREY};
    &:hover:not(:disabled) { background: #f6f8fa; }
  `,
  navy: css`
    background: ${COLORS.COLOR_DARK};
    color: ${COLORS.PRIMARY_WHITE};
    border: none;
    box-shadow: 0 2px 6px rgba(41, 52, 97, 0.22);
    &:hover:not(:disabled) { filter: brightness(1.1); }
  `,
  ghost: css`
    background: transparent;
    color: ${COLORS.BTN_GREEN};
    border: none;
    &:hover:not(:disabled) { background: rgba(0, 131, 140, 0.08); }
  `,
  danger: css`
    background: ${COLORS.NOTIFICATION_RED};
    color: #b83939;
    border: 1.5px solid #eababa;
    &:hover:not(:disabled) { background: #f9dcdc; }
  `,
  gold: css`
    background: #f6b436;
    color: #3e2e00;
    border: none;
    box-shadow: 0 2px 6px rgba(246, 180, 54, 0.3);
    &:hover:not(:disabled) { filter: brightness(0.95); }
  `,
};

const sizes = {
  sm: css`padding: 7px 14px; font-size: 12px;`,
  md: css`padding: 9px 18px; font-size: 13px;`,
  lg: css`padding: 12px 24px; font-size: 14px;`,
};

const StyledButton = styled.button`
  font-family: ${theme.fonts.primaryFontBold};
  font-weight: 700;
  border-radius: 7px;
  letter-spacing: 0.01em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
  transition: all 0.15s ease;
  ${({ $variant }) => variants[$variant] || variants.primary}
  ${({ $size }) => sizes[$size] || sizes.md}
`;

const IconSpan = styled.span`
  font-size: ${({ $size }) => ($size === "lg" ? "16px" : $size === "sm" ? "14px" : "15px")};
  line-height: 1;
`;

const Button = ({
  children,
  variant = "primary",
  size = "md",
  onClick,
  icon,
  disabled,
  fullWidth,
  type = "button",
}) => (
  <StyledButton
    type={type}
    $variant={variant}
    $size={size}
    $disabled={disabled}
    $fullWidth={fullWidth}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    {icon && <IconSpan $size={size}>{icon}</IconSpan>}
    {children}
  </StyledButton>
);

export default Button;
